import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showSubmitRequestModal } from '../support/submitRequest/store/actions';

class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  static reloadPage() {
    return window.location.reload();
  }

  static propTypes = {
    showSubmitRequestModal: PropTypes.func.isRequired,
    global: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]),
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    console.log('ErrorBoundary', error, errorInfo); // eslint-disable-line no-console
  }

  render() {
    const { children, showSubmitRequestModal, global } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div className="general-info-page page-without-secondary-menu page-content-container">
          <div className="general-info-text">
            <div>An unexpected error has occurred</div>
            {!global && (
              <div>
                If the problem persists, please
                <button className="link-button general-info-link" onClick={showSubmitRequestModal}>&nbsp;report an issue</button>
              </div>
            )}
            <br />
            <div>
              <button className="link-button general-info-link" onClick={ErrorBoundary.reloadPage}>Reload this page</button>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default connect(
  null,
  {
    showSubmitRequestModal,
  }
)(ErrorBoundary);
